import { render, staticRenderFns } from "./DecoEntryForResult.vue?vue&type=template&id=4a8c8be0&"
import script from "./DecoEntryForResult.vue?vue&type=script&lang=ts&"
export * from "./DecoEntryForResult.vue?vue&type=script&lang=ts&"
import style0 from "./DecoEntryForResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports